import React from 'react';
import { useSelector } from 'react-redux';
import Loading from '@components/common/Loading';
import RecommendationUpsell from '@components/cart/recommendations/RecommendationUpsell';
import useWindowDimensions from '@hooks/useWindowDimensions';

const YouMayAlsoLike = ({ minicart = false }) => {
	const cartAddOnProducts = useSelector(state => state.cart.cartAddOnProducts);
	const othersKey = useSelector(state => state.cart.othersKey);
	const { width: viewportWidth } = useWindowDimensions();

	const copy = {
		'glasses-case': 'Protect your Pair in our secure and durable, yet lightweight case.',
		'top-frame-case': 'Take two more of your favorite top frames on-the-go with our ultra-portable case.',
		'wall-hanger':
			'Our wall hanger allows you to magically display up to 5 top frames and even has a pocket at the bottom for your base frame!',
		'cleaning-kit': 'The all-in-one kit includes lens cleaning spray, a micro-fiber cloth, and a carrying kit.',
	};

	return (
		<section data-test='you-may-also-like'>
			<div className='p-0'>
				<h2 className='col title mb-8 h2 title-poppins'>Also worth checking out</h2>
				<div className={`${(viewportWidth < 992 || minicart) && 'm-0'}`} id='addOnRoot'>
					{Object.entries(cartAddOnProducts).map(
						([handle, addOn]) =>
							addOn &&
							addOn.available && (
								<RecommendationUpsell
									key={handle}
									recommendation={addOn}
									bundleKey={othersKey}
									addlInfo={copy[handle]}
									itemGroupKey={othersKey}
								/>
							)
					) ?? <Loading phrase='' />}
				</div>
			</div>
		</section>
	);
};

export default YouMayAlsoLike;
